import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Socket } from 'ngx-socket-io';

import { io } from 'socket.io-client';
import { Observable, catchError, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FuseConfigService } from '@fuse/services/config';
@Injectable({
    providedIn: 'root',
})
export class AppService {

    private _apiUrl: string = environment.apiUrl;
    settings: any;
    user: any;
    //private socket: Socket;
    constructor(private router: Router, private socket: Socket, private _httpClient: HttpClient,
        private _fuseConfigService: FuseConfigService,
    ) {
        this.getSettings().pipe(
            catchError(error => {
                console.error('App service error', error);
                return of(null); // Replace with default value or keep it null
            })
        ),


            // Establish the Socket.IO connection with the user ID
            this.user = JSON.parse(localStorage.getItem('user'));
        if (this.user && this.user._id) {
            this.socket.emit('register', {
                _id: this.user._id,
            });
            this.socket.connect();
        }
    }

    getSettings(): Observable<any> {
        return this._httpClient.get(this.getApiUrl() + 'setting/get_site_settings').pipe(
            tap((res: any) => {
                // Perform your action here
                // For example, save the data in a variable
                this.settings = res.data;
                let scheme = localStorage.getItem('scheme') ? localStorage.getItem('scheme') : 'light';
                this._fuseConfigService.config = { scheme };

                let theme = localStorage.getItem('theme') ? localStorage.getItem('theme') : '"theme-default"';


                this._fuseConfigService.config = { theme };

                const logoUrl = this.settings.websiteLogo
                const logoElement = document.querySelector('.fuse-splash-screen img') as HTMLImageElement;
                if (logoElement) {
                    logoElement.src = logoUrl;
                }

            }),
            catchError(error => {
                console.error('App service error', error);
                return of(null); // Replace with default value or keep it null
            })
        );
    }



    getApiUrl() {
        return this._apiUrl;
    }

    getSiteSettings() {
        return this._apiUrl;
    }

    navigateToAppLogin() {
        this.router.navigate(['']);
    }

    navigateToDashboard() {
        this.router.navigate(['logged-in/user/dashboard']);
    }

    public listenForNotifications(): Observable<any> {
        return new Observable((observer) => {
            this.socket.on('notification', (data) => {
                observer.next(data);
            });
        });
    }

    downloadFile(fileName: string) {
        return this._httpClient.get(this.getApiUrl() + 'service/download/' + fileName, {
            responseType: 'blob',
            observe: 'response'
        });
    }
}
